import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  addUserReducer,
  getRoleReducer,
  getUserByIDReducer,
  getUsersReducer,
  userLoginReducer,
  resetDeviceIDReducer,
  resetPasswordReducer,
  updateUserReducer,
  userLogoutReducer,
  fetchAttendanceReducer,
  resignUserReducer,
  forceLogoutUserReducer,
  forceLogoutMultipleReducer,
} from './reducers/userReducers';
import {
  addRoleReducer,
  getRoleByIDReducer,
  getRolesReducer,
  updateRoleReducer,
} from './reducers/roleReducers';
import {
  categoryListReducer,
  categoryDetailsReducer,
  categoryCreateReducer,
  categoryUpdateReducer,
  categoryDeleteReducer,
} from './reducers/categoryReducers';
import {
  eventListReducer,
  eventDetailsReducer,
  eventCreateReducer,
  eventUpdateReducer,
  eventDeleteReducer,
} from './reducers/eventReducers';
import {
  getCheckersReducer,
  createCheckerReducer,
  updateCheckerReducer,
  deleteCheckerReducer,
  assignEventsReducer,
} from './reducers/checkerReducers';

const reducer = combineReducers({
  // User reducers
  userLogin: userLoginReducer,
  userLogout: userLogoutReducer,
  getRoleInfo: getRoleReducer,
  getUsersInfo: getUsersReducer,
  addUserInfo: addUserReducer,
  getUserByIDInfo: getUserByIDReducer,
  updateUserInfo: updateUserReducer,
  resetDeviceIDInfo: resetDeviceIDReducer,
  resetPasswordInfo: resetPasswordReducer,
  fetchAttendanceInfo: fetchAttendanceReducer,
  resignUserInfo: resignUserReducer,
  forceLogoutUserInfo: forceLogoutUserReducer,
  forceLogoutMultipleInfo: forceLogoutMultipleReducer,

  // Role reducers
  getRolesInfo: getRolesReducer,
  addRoleInfo: addRoleReducer,
  getRoleByIDInfo: getRoleByIDReducer,
  updateRoleInfo: updateRoleReducer,

  // Category reducers
  categoryList: categoryListReducer,
  categoryDetails: categoryDetailsReducer,
  categoryCreate: categoryCreateReducer,
  categoryUpdate: categoryUpdateReducer,
  categoryDelete: categoryDeleteReducer,

  // Event reducers
  eventList: eventListReducer,
  eventDetails: eventDetailsReducer,
  eventCreate: eventCreateReducer,
  eventUpdate: eventUpdateReducer,
  eventDelete: eventDeleteReducer,

  // Checker reducers
  getCheckersInfo: getCheckersReducer,
  createCheckerInfo: createCheckerReducer,
  updateCheckerInfo: updateCheckerReducer,
  deleteCheckerInfo: deleteCheckerReducer,
  assignEventsInfo: assignEventsReducer,
});

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const preloadedState = {
  userLogin: { userInfo: userInfoFromStorage },
};

const store = configureStore({
  reducer,
  preloadedState,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
});

export default store;
